import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import BackendConnectionService from '../../ports/backend/backendConnectionService';
import LocalStorageService from '../../ports/localStorage/localStorageService';

export default function EventChart() {
  const [series, setSeries] = useState([]);
  const [loading, setLoading] = useState(true);

  
  useEffect(() => {
    const EVENT_LABELS = {
    QUERY_DNI: "Consulta de DNI",
    QUERY_PASSPORT: "Consulta de Pasaporte",
    DNI_FILE_PROCESSING_SUCCESS: "Archivo de DNIs procesado exitosamente",
    PASS_FILE_PROCESSING_SUCCESS: "Archivo de Pasaportes procesado exitosamente",
    DNI_FILE_PROCESSING_FAIL: "Error al procesar archivo de DNIs",
    PASS_FILE_PROCESSING_FAIL: "Error al procesar archivo de Pasaportes",
    };
    const token = LocalStorageService.getUserToken();
    BackendConnectionService.getEventChartData(token)
      .then((json) => {
        json = json.data;
        if (json && json.events) {
          const translated = json.events.map((event) => ({
            name: EVENT_LABELS[event.name] || event.name,
            data: event.data,
            }));  
          setSeries(translated);
        } else {
          setSeries([]);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error loading chart data:', err);
        setLoading(false);
      });
  }, []);

  const options = {
    chart: {
      type: 'line',
      height: 350,
      zoom: { enabled: false },
    },
    defaultLocale: 'es',
    locales: [{
        name: 'es',
        options: {
        toolbar: {
            exportToSVG: 'Descargar SVG',
            exportToPNG: 'Descargar PNG',
            exportToCSV: 'Descargar CSV',
            selection: 'Seleccionar',
            selectionZoom: 'Zoom de selección',
            zoomIn: 'Acercar',
            zoomOut: 'Alejar',
            pan: 'Mover',
            reset: 'Reiniciar zoom'
        },
        }
    },],
    xaxis: {
      type: 'category',
      title: { text: 'Fecha' },
      labels: { rotate: -45 },
    },
    yaxis: {
      title: { text: 'Eventos' },
    },
    stroke: {
      curve: 'smooth',
    },
    title: {
      text: '',
      align: 'left',
    },
    legend: {
      position: 'top',
    },
    tooltip: {
      x: {
        format: 'yyyy-MM-dd',
      },
    },
    
  };

  if (loading) return <p>Cargando datos...</p>;
  if (!series.length) return <p>No hay información disponible aún.</p>;

  return (
    <Chart options={options} series={series} type="line" height={400} />
  );
}
